export default function isActiveInlineStyle(editorState, style) {
  return editorState.getCurrentInlineStyle().has(style);
}
